import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ContentChild,
  TemplateRef,
  ElementRef,
} from '@angular/core';
import { MatMenu } from '@angular/material/menu';

export interface ActionMenuItemConfig {
  label: string;
  action?: string;
  icon?: string;
  iconClass?: string;
  disabled?: boolean;
  variant?: 'default' | 'primary' | 'danger';
  to?: string;
  copyValue?: string;
  hidden?: boolean;
}

@Component({
  selector: 'app-action-menu',
  templateUrl: './app-action-menu.component.html',
  styleUrls: ['./app-action-menu.component.scss'],
})
export class AppActionMenuComponent {
  @ViewChild('matMenu') matMenu!: MatMenu;

  @ContentChild('trigger') customTriggerRef?: ElementRef;

  @Input() headerText: string = 'Actions';
  @Input() showHeader: boolean = true;
  @Input() xPosition: 'before' | 'after' = 'before';
  @Input() yPosition: 'above' | 'below' = 'below';
  @Input() triggerVariant: 'default' | 'bordered' | 'ghost' = 'default';
  @Input() triggerSize: 'sm' | 'md' | 'lg' = 'md';
  @Input() customClass: string = '';
  @Input() menuClass: string = '';
  @Input() disabled: boolean = false;
  @Input() customTrigger: boolean = false;
  @Input() items: ActionMenuItemConfig[] = [];

  get hasCustomTrigger(): boolean {
    return this.customTrigger || !!this.customTriggerRef;
  }

  @Output() itemClick = new EventEmitter<{ item: ActionMenuItemConfig; event: MouseEvent }>();
  @Output() menuOpened = new EventEmitter<void>();
  @Output() menuClosed = new EventEmitter<void>();

  onItemClick(item: ActionMenuItemConfig, event: MouseEvent): void {
    if (item.disabled) return;
    event.stopPropagation();
    this.itemClick.emit({ item, event });
  }

  stopPropagation(event: MouseEvent): void {
    event.stopPropagation();
  }
}
